import React from "react";
import { Button as MuiButton, ButtonProps as MuiButtonProps } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { GetMaterialYouButtonStyles } from "lib/styles/button";

export interface ButtonProps extends MuiButtonProps {
	variant?: "contained" | "outlined" | "text";
	color?: "primary" | "secondary" | "inherit" | "error" | "info" | "success" | "warning";
}

export function Button({
	variant = "contained",
	color = "primary",
	children,
	...rest
}: ButtonProps) {
	const theme = useTheme();
	const sx = GetMaterialYouButtonStyles(theme, variant, color);

	return (
		<MuiButton
			variant={variant}
			color={color}
			sx={sx}
			disableElevation
			{...rest}
		>
			{children}
		</MuiButton>
	);
}

export default Button;
